var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.812.719-8.875-13.89A.5.5,0,0,0-9.187-14a.5.5,0,0,0-.391.187l-.312.39a.5.5,0,0,0-.11.313.5.5,0,0,0,.188.391L8.875,1.89a.5.5,0,0,0,.7-.078l.312-.39a.5.5,0,0,0-.078-.7ZM-.725-9.423,3.487-6.13A3.491,3.491,0,0,0,0-9.5,3.493,3.493,0,0,0-.725-9.423ZM.725-2.577-3.487-5.87A3.491,3.491,0,0,0,0-2.5,3.517,3.517,0,0,0,.725-2.577ZM0-10.5A8.5,8.5,0,0,1,7.435-6,8.891,8.891,0,0,1,6.06-4.119L7.24-3.2A10.4,10.4,0,0,0,8.893-5.544,1.006,1.006,0,0,0,9-6a1.014,1.014,0,0,0-.108-.457A10.027,10.027,0,0,0,0-12a9.648,9.648,0,0,0-3.27.588l1.45,1.134A8.2,8.2,0,0,1,0-10.5Zm0,9A8.5,8.5,0,0,1-7.435-6,8.888,8.888,0,0,1-6.059-7.881L-7.238-8.8A10.4,10.4,0,0,0-8.891-6.456,1.006,1.006,0,0,0-9-6a1.014,1.014,0,0,0,.108.457A10.023,10.023,0,0,0,0,0,9.686,9.686,0,0,0,3.27-.588L1.819-1.722A8.218,8.218,0,0,1,0-1.5Z",
    transform: "translate(12 18)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye_off.aa653677.svg";
export { ForwardRef as ReactComponent };